import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "zxStudentRoll/";

// 论坛 - 列表
export const getMyRoll = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "getMyRoll", {
    data: _params,
    method: "GET",
  });
};

// 论坛 - 添加
export const getMyStudent = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "getMyStudent", {
    data: _params,
    method: "GET",
  });
};



// WEBPACK FOOTER //
// ./src/fetch/api/roll.js